import styled from 'styled-components';

import { TransparentButton, Typography } from '@libs/components';
import { DISCLAIMER_HEIGHT } from 'src/constants';

import DashboardNavItem from './component/DashboardNavItem';
import { DASHBOARD_NAV_WIDTH } from './DashboardNav';
import { Dropdown } from './component/Dropdown';

type ShadowProps = {
  shadow?: string;
};

export const CustomDashboardNavItem = styled(DashboardNavItem)`
  border-radius: ${({ theme }) => theme.borderRadius.high};
`;

type NavProps = {
  isUnderConstruction?: boolean;
  isAppDisclaimerVisible?: boolean;
};

export const Nav = styled.nav<NavProps>`
  display: none;

  z-index: ${({ theme }) => theme.zIndex.high};

  background-color: ${({ theme }) => theme.colors.surface.default};

  ${({ theme, isUnderConstruction, isAppDisclaimerVisible }) => {
    const borderColor = theme.colors.borders
      .default as unknown as TemplateStringsArray;
    const dashboardWidth =
      DASHBOARD_NAV_WIDTH.toString() as unknown as TemplateStringsArray;

    let top: TemplateStringsArray;

    if (isAppDisclaimerVisible && isUnderConstruction) {
      top = `${DISCLAIMER_HEIGHT * 2}rem` as unknown as TemplateStringsArray;
    } else if (isAppDisclaimerVisible || isUnderConstruction) {
      top = `${DISCLAIMER_HEIGHT}rem` as unknown as TemplateStringsArray;
    } else {
      top = '0' as unknown as TemplateStringsArray;
    }

    const minHeight = (isUnderConstruction || isAppDisclaimerVisible
      ? '-webkit-fill-available'
      : '100%') as unknown as TemplateStringsArray;
    return theme.media.laptop`
      display: flex;
      flex-direction: column;
      // justify-content: space-between;

      position: fixed;
      top: ${top};
      left: 0;

      max-height: 100%;
      min-height: ${minHeight};
      width: 100%;
      max-width: ${dashboardWidth}rem;
      min-width: ${dashboardWidth}rem;

      padding: 2.7rem 0 0;

      border-right: 1px solid ${borderColor};
      
      transform: unset;
    `;
  }}
`;

export const NavWrapper = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;

  /* flex: 1; */
  overflow-y: auto;
`;

export const HomePage = styled(TransparentButton)`
  display: none;

  ${({ theme }) => theme.media.laptop`
    display:flex;

    margin-left:3.2rem;
  `};
`;

export const BitnetLogo = styled.img`
  height: 3.3rem;
`;

export const UserDetailsWrapper = styled.div`
  display: none;

  ${({ theme }) => theme.media.laptop`
    display: flex;

    margin: 6.3rem 0 5.3rem 3.2rem ;
  `}
`;

export const PaddingWrapper = styled.div`
  padding: 0 3.2rem 0 2.9rem;
  min-width: unset;
  &:last-child {
    padding: 1.2rem 0;
    margin-top: 1.2rem;
    border-top: 0.05rem solid ${({ theme }) => theme.colors.borders.default};
  }
  ${({ theme }) => theme.media.laptop`
    display:flex;
    flex-direction:column;
    align-items:center;
    // max-width: 23.6rem;
    padding: 0;
    margin: 0 1.2rem;
    // min-width: 21.6rem;
`}
`;

export const LanguageWrapper = styled.div`
  height: 8rem;

  display: flex;
  margin-top: 1.6rem;
  align-items: center;
  justify-content: center;
  border-top: 1px solid ${({ theme }) => theme.colors.borders.default};
`;

export const Shadow = styled.div<ShadowProps>`
  width: 100%;
  height: 5.5rem;
  background: ${({ shadow }) => shadow};
  @media only screen and (min-height: 900px) {
    display: none;
  }
`;

export const SupportNav = styled.div`
  min-height: 10rem;
  margin: 1.2rem 1.2rem 0;
  border-top: 0.05rem solid ${({ theme }) => theme.colors.borders.default};
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.interactive.secondary};
  margin-bottom: 4rem;
`;
export const OffersTitle = styled(Typography)`
  margin-left: 1.2rem;
  margin-bottom: 0.8rem;
  align-self: baseline;
`;
export const CustomDropdown = styled(Dropdown)`
  .body {
    min-height: 22rem;
  }
`;
